const MK_TZ = "Asia/Dubai";
const MK_CITIES = {
  AUH: ["Abu Dhabi", "أبوظبي"],
  AAN: ["Al Ain", "العين"],
  MZY: ["Madinat Zayed", "مدينة زايد"],
  RUW: ["Ruwais", "الرويس"],
  LIW: ["Liwa Oasis", "واحة ليوا"],
  DXB: ["Dubai", "دبي"],
  JAL: ["Jebel Ali", "جبل علي"],
  HTA: ["Hatta", "حتا"],
  SHJ: ["Sharjah", "الشارقة"],
  KFK: ["Khor Fakkan", "خورفكان"],
  KLB: ["Kalba", "كلباء"],
  ADH: ["Al Dhaid", "الذيد"],
  AMD: ["Al Madam", "المدام"],
  MLH: ["Mleiha", "مليحة"],
  AJM: ["Ajman", "عجمان"],
  UAQ: ["Umm Al Quwain", "أم القيوين"],
  RAK: ["Ras Al Khaimah", "رأس الخيمة"],
  FUJ: ["Fujairah", "الفجيرة"],
  DFA: ["Dibba Al-Fujairah", "دبا الفجيرة"],
  MAF: ["Masafi", "مسافي"],
};
const MK_PLATE_CLASS = {
  Personal: ["Private", "خصوصي"],
  Private: ["Private", "خصوصي"],
  Commercial: ["Commercial", "تجاري"],
  Taxi: ["Taxi", "أجرة"],
};
const MK_EXPIRY_WARN_DAYS = 30;

const mkClean = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  return !s || ["null", "undefined", "''", '""'].includes(s) ? "" : s;
};

const mkDate = (v) => {
  const s = mkClean(v);
  if (!s) return "";
  const d = new Date(s);
  if (isNaN(d)) return s;
  const p = new Intl.DateTimeFormat("en-GB", {
    timeZone: MK_TZ,
    day: "2-digit",
    month: "short",
    year: "2-digit",
  }).formatToParts(d);
  const g = (t) => p.find((x) => x.type === t)?.value || "";
  return `${g("day")}-${g("month").toUpperCase()}-${g("year")}`;
};

const mkNum = (v, unit, digits) => {
  const s = mkClean(v);
  if (!s) return "";
  const n = Number(s);
  if (!isFinite(n) || n === 0) return "";
  return (
    n.toLocaleString("en-US", { maximumFractionDigits: digits ?? 0 }) +
    (unit ? ` ${unit}` : "")
  );
};

const mkStatus = (exp) => {
  const s = mkClean(exp);
  const days = s
    ? Math.floor((new Date(s) - new Date()) / 86400000)
    : NaN;
  if (isNaN(days)) return ["na", "No expiry date"];
  if (days < 0) return ["bad", "Registration expired"];
  if (days <= MK_EXPIRY_WARN_DAYS)
    return ["warn", `Expires in ${days} day${days === 1 ? "" : "s"}`];
  return ["ok", "Registration valid"];
};

export const mapVehicleToMulkiya = (v = {}) => {
  const a = v.attributes || {};
  const sc = mkClean(a.cityShortCode).toUpperCase();
  const city = MK_CITIES[sc] || [sc, ""];
  const tag = mkClean(a.tag_1);
  const cls = MK_PLATE_CLASS[tag] || [tag, ""];
  const make = mkClean(v.makeName) || mkClean(a.make);
  const model = mkClean(v.modelName) || mkClean(a.model);
  return {
    plate: mkClean(v.vehicleLicensePlate) || mkClean(v.label),
    plateArabic: mkClean(v.vehicleLisencePlateArabic),
    cityEn: city[0],
    cityAr: city[1],
    contractNumber: mkClean(a.contractNumber),
    plateCategory: cls[0],
    plateCategoryAr: cls[1],
    owner: mkClean(a.parentName),
    id: mkClean(v.id),
    expDate: mkDate(v.expirationTime),
    regDate: mkDate(v.created),
    insExp: mkDate(v.insuranceTime),
    lease: v.onLease ? "Yes" : "No",
    year: mkClean(a.year),
    variant: mkClean(a.variant),
    origin: mkClean(a.country),
    color: mkClean(a.color),
    fuel: mkClean(a.fuel_type),
    vehType: [make, model, mkClean(v.category)].filter(Boolean).join(" · "),
    transmission: mkClean(a.trasmissionType),
    capacity: mkClean(a.capacity),
    odometer: mkNum(v.odometer, "KM"),
    efficiency: mkNum(v.fuelEfficiency, "L/100KM", 1),
    vin: mkClean(a.chassisNumber) || mkClean(v.vin),
    imei: mkClean(v.imei),
    _status: mkStatus(v.expirationTime),
    _sub: [
      mkClean(v.vehicleLicensePlate),
      [make, model, mkClean(a.year)].filter(Boolean).join(" "),
    ]
      .filter(Boolean)
      .join(" · "),
  };
};
